<template lang="pug">

transition(
  appear
)
  .icon-more
    svg(width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg")
      path(d="M0.900024 18.6001C1.10002 18.8001 1.40002 19.0001 1.80002 19.0001C2.10002 19.0001 2.40002 18.9001 2.70002 18.6001L7.60002 13.7001C8.80002 14.5001 10.2 15.0001 11.7 15.0001C15.7 15.0001 18.9 11.7001 18.9 7.8001C18.9 3.8001 15.6 0.600098 11.7 0.600098C7.70002 0.600098 4.50002 3.9001 4.50002 7.8001C4.50002 9.3001 5.00002 10.8001 5.80002 11.9001L0.900024 16.8001C0.400024 17.3001 0.400024 18.1001 0.900024 18.6001ZM11.7 14.4001C8.10002 14.4001 5.10002 11.4001 5.10002 7.8001C5.10002 4.2001 8.10002 1.2001 11.7 1.2001C15.3 1.2001 18.3 4.2001 18.3 7.8001C18.3 11.4001 15.4 14.4001 11.7 14.4001Z" fill="white" stroke="white" stroke-miterlimit="10")



</template>

<script>
export default {
  name: 'icon-share',
  components: {},
  data() {
    return {}
  },
  props: {},
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-more










</style>
